import BlurFadeText from "@/components/common/blurFadeText";

export default function SectionEyebrow({
  text,
  className = "",
  textClassName = "",
  amount,
  delay,
  blur,
  y,
}) {
  return (
    <div className={`flex items-center gap-3 pt-2 text-primary ${className}`}>
      <span className="h-2.5 w-2.5 bg-current" />
      <p
        className={`font-raleway text-sm font-semibold uppercase tracking-[0.16em] text-[#06040c]/62 sm:text-base ${textClassName}`}
      >
        <BlurFadeText
          text={text}
          amount={amount}
          delay={delay}
          blur={blur}
          y={y}
        />
      </p>
    </div>
  );
}
